"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWebChatAPIContext;

var _react = require("react");

var _WebChatAPIContext = _interopRequireDefault(require("./WebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useWebChatAPIContext() {
  var context = (0, _react.useContext)(_WebChatAPIContext.default);

  if (!context) {
    throw new Error('This hook can only be used on a component that is a descendant of <Composer>');
  }

  return context;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dC5qcyJdLCJuYW1lcyI6WyJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsImNvbnRleHQiLCJXZWJDaGF0QVBJQ29udGV4dCIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFFZSxTQUFTQSxvQkFBVCxHQUFnQztBQUM3QyxNQUFNQyxPQUFPLEdBQUcsdUJBQVdDLDBCQUFYLENBQWhCOztBQUVBLE1BQUksQ0FBQ0QsT0FBTCxFQUFjO0FBQ1osVUFBTSxJQUFJRSxLQUFKLENBQVUsOEVBQVYsQ0FBTjtBQUNEOztBQUVELFNBQU9GLE9BQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IFdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VXZWJDaGF0QVBJQ29udGV4dCgpIHtcbiAgY29uc3QgY29udGV4dCA9IHVzZUNvbnRleHQoV2ViQ2hhdEFQSUNvbnRleHQpO1xuXG4gIGlmICghY29udGV4dCkge1xuICAgIHRocm93IG5ldyBFcnJvcignVGhpcyBob29rIGNhbiBvbmx5IGJlIHVzZWQgb24gYSBjb21wb25lbnQgdGhhdCBpcyBhIGRlc2NlbmRhbnQgb2YgPENvbXBvc2VyPicpO1xuICB9XG5cbiAgcmV0dXJuIGNvbnRleHQ7XG59XG4iXX0=